var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h5", { staticClass: "mb-3" }, [
      _vm._v("\n    " + _vm._s(_vm.dataComponent.name) + "\n  ")
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "tabs mt-4" },
      _vm._l(_vm.tabs, function(tab, index) {
        return _c(
          "div",
          {
            key: tab,
            staticClass: "tab-list",
            class: { "tab-active": index === 0 }
          },
          [_vm._v("\n      " + _vm._s(tab) + "\n    ")]
        )
      })
    ),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "d-flex align-items-center mt-3" },
      [
        _c("b-button", { staticClass: "btn blue m__r--5" }, [
          _vm._v("Create Task Project")
        ]),
        _vm._v(" "),
        _c("b-button", { staticClass: "btn outline grey m__r--5" }, [
          _c("i", { staticClass: "fa fa-download" })
        ]),
        _vm._v(" "),
        _c(
          "b-button",
          {
            staticClass: "btn outline grey m__r--5",
            staticStyle: { "border-color": "#dfdfea" }
          },
          [_vm._v("\n      Import File\n    ")]
        ),
        _vm._v(" "),
        _c("b-button", { staticClass: "btn green" }, [_vm._v("Export XLS")])
      ],
      1
    ),
    _vm._v(" "),
    _vm._m(1),
    _vm._v(" "),
    _c("div", { staticClass: "columns mt-3" }, [
      _c(
        "div",
        { staticClass: "d-flex align-items-center" },
        _vm._l(_vm.columns, function(column) {
          return _c(
            "div",
            { key: column, staticClass: "column" },
            [
              _c(
                "div",
                {
                  staticClass: "header-list",
                  staticStyle: { cursor: "default !important" }
                },
                [
                  _c("div", { staticClass: "column-name" }, [
                    _vm._v(_vm._s(column))
                  ])
                ]
              ),
              _vm._v(" "),
              _vm._l(4, function(index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "column-preview",
                    class: { "bg-gray": index === 2 || index === 4 },
                    staticStyle: { cursor: "default !important" }
                  },
                  [_c("div", { staticClass: "content-preview" })]
                )
              })
            ],
            2
          )
        })
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex justify-content-end mt-3" }, [
      _c("i", { staticClass: "fa fa-cogs icon-setting" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "advanced-search" }, [
      _vm._v("Advanced Search "),
      _c("i", { staticClass: "fa fa-angle-right" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17b71a83", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17b71a83","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dummy/DummyTimesheetConfig.vue
// module id = null
// module chunks = 